import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Target from '@nerdwallet/react-icon/gizmo/Target';
import classNames from 'classnames';

import { moveComponent } from '../../lib/redux/actions/builder';

const Dropzone = ({ name, dispatch, sortingComponentId, targetId }) => {
  const [on, setOn] = useState(false);

  return (
    <a
      className={classNames({
        'editor-control__dropzone': true,
        'editor-control__dropzone-on': on,
        'editor-control__dropzone-visible': sortingComponentId,
      })}
      title={`Above ${name}`}
      onDragEnter={() => {
        setOn(true);
      }}
      onDragLeave={() => {
        setOn(false);
      }}
      onDragOver={(evt) => {
        // this lets the browser know this is a valid drop zone
        evt.preventDefault();
      }}
      onDrop={() => {
        if (sortingComponentId) {
          dispatch(moveComponent(sortingComponentId, targetId));
        }
      }}
    >
      {sortingComponentId ? <Target /> : null}
    </a>
  );
};

Dropzone.propTypes = {
  targetId: PropTypes.string.isRequired,
  name: PropTypes.string,
  sortingComponentId: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

Dropzone.defaultProps = {
  sortingComponentId: '',
  name: '',
};

export default Dropzone;
